import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../../app/state/app.selectors';
import * as fromProjectTask from './project-task.reducers';

export interface ProjectTaskState {
  stateData: fromProjectTask.State;
}

export interface State extends fromRoot.AppState {
  projectTask: ProjectTaskState;
}

export const reducers = {
  stateData: fromProjectTask.reducer
};

export const selectProjectTaskState = createFeatureSelector<ProjectTaskState>('projectTask');

export const selectProjectTaskStateData = createSelector(selectProjectTaskState, (state: ProjectTaskState) => state.stateData);

export const getProjectTaskState = createSelector(selectProjectTaskStateData, fromProjectTask.getStateData);

export const getProjectTaskScreenError = createSelector(selectProjectTaskStateData, fromProjectTask.getError);

export const getProjectTaskScreenPending = createSelector(selectProjectTaskStateData, fromProjectTask.getPending);